import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DownloadLink } from 'src/app/_models/downloadLinks.vm';
import { trackByIndex } from '../utils/track-by';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-download-link-list',
    templateUrl: './download-link-list.component.html',
    styleUrls: ['./download-link-list.component.scss'],
    standalone: false
})
export class DownloadLinkListComponent {
  public readonly trackByIndex = trackByIndex;


  @Input() public links: Array<DownloadLink>

}
